import apiClient from "@/utils/httpClient";
import { CreateOrganizationRequest, OrganizationResponse } from "@/interfaces/organization.interface";

export const createOrganization = async (
  data: CreateOrganizationRequest
): Promise<OrganizationResponse> => {
  return apiClient.post<OrganizationResponse>("/organizations", data);
};
